import Input from '../../empreenderUI/ui/Input'
import { Search } from 'lucide-react'
import { useState } from 'react'

export default function SearchBar(props: any) {
  const [isFocused, setIsFocused] = useState(true)

  function searchData(e: any) {
    e.preventDefault()
    props.setSearch?.(e.target.value)
  }

  return (
    <div className={`grid grid-cols-1 ${props.className || ''}`}>
      <Input
        placeholder={!isFocused ? '' : props.placeholder}
        onFocus={() => setIsFocused(false)}
        onBlur={() => setIsFocused(true)}
        onChange={(e) => searchData(e)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') props.onSubmit?.()
        }}
        {...(props.value !== undefined ? { value: props.value } : {})}
        className="bg-gray-50 !py-2 !px-3 !pl-10 placeholder:text-gray-400 col-start-1 row-start-1"
      />
      <Search
        aria-hidden="true"
        className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400"
      />
    </div>
  )
}
